
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Popup.module.css";
import commonStyles from "components/commonStyle/commonStyle.module.css";
import { LoginCred, RegistrierenLoginPopupProps } from "modules/register-login";
import { FaArrowAltCircleRight } from "react-icons/fa";
import ErrorFailed from "components/errorFailed/errorFailed";
import { checkEmail } from "services/userLogin/check-email";
import { loginUser } from "services/userLogin/user-login";
import ConfirmEmailResetPasswordPopup from "./confirmEmailResetPasswordPopup";




export default function LoginPopup({ isOpen, onClose, togglePopup }: RegistrierenLoginPopupProps) {
    const [animationState, setAnimationState] = useState("popupExit");
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [resetPasswordPopup, setResetPasswordPopup] = useState(false);
    const [formLoginData, setFormLoginData] = useState<LoginCred>({
        email: '',
        password: '',
    });

    useEffect(() => {
        if (isOpen) {
            setAnimationState("popupEnter");
        } else {
            setAnimationState("popupExit");
            resetForm();
        }
    }, [isOpen]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormLoginData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    };

    const resetForm = () => {
        setFormLoginData({
            email: '',
            password: '',
        });
        setError(null);
        setResetPasswordPopup(false);
    };

    const validateForm = async (): Promise<boolean> => {
        if (formLoginData.password === '') {
            setError("Die Passwort ist erforderlich.");
            return false;
        }

        if (formLoginData.email === '') {
            setError("Die email ist erforderlich.");
            return false;
        }
        

        try {
            const res = await checkEmail(formLoginData.email);
            if (!res.exists || res.is_archived) {
                setError("Ungültige E-Mail oder Passwort.");
                return false;
            }
        } catch (error) {
            setError("Serverfehler. Bitte versuchen Sie es später noch einmal.");
            return false;
        }

        return true;
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setError(null);
        const isValid = await validateForm();
        if (!isValid) return;
        try {
            const responseData = await loginUser({
                email: formLoginData.email,
                password: formLoginData.password,
            
            });
            if (!responseData.success) {
                setError(responseData.message ? responseData.message: "Fehler beim Login.");
            }
            else {
                const { is_customer, is_employee, is_password_completed, is_statistic, is_profile_completed, has_kid } = responseData.user;
                if (is_employee) {
                    onClose();
                    if (!is_password_completed) {
                        navigate('/reservierungsportal/EmploySetPassword');
                    } else if (is_statistic) {
                        navigate('/reservierungsportal/StatisticPage');
                    } else {
                        navigate('/reservierungsportal/EmployHomePage');
                    }
                }
                else if (is_customer) {
                    if (!is_profile_completed) {
                        onClose();
                        navigate('/reservierungsportal/compliatProfile')
                    } else {
                        onClose();
                        has_kid ? navigate('/reservierungsportal/CustomerHomePage') : navigate('/reservierungsportal/NewkidsProfile');
                    }

                }
                else {

                    setError("Fehler beim Login.");
                }
            }

        } catch (error) {
            setError("Serverfehler. Bitte versuchen Sie es später noch einmal.");

        }
    };

    if (!isOpen && animationState === "popupExit") return null;
    return (<>
        <div className={`${styles.popupContainer} ${styles[animationState]}`}>
            <div className={styles.popupContent}>
                <div className={styles.popupheader}>
                    <h2>Login</h2>
                    <button className={styles.closeButton} onClick={onClose}>
                        &times;
                    </button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className={styles.form}>
                        {error && <ErrorFailed error={error} />}
                        <div className={styles.formGroup}>
                            <label htmlFor="email">E-Mail</label>
                            <input type="email"
                                id="email"
                                name="email"
                                value={formLoginData.email}
                                onChange={handleChange} required />
                        </div>
                        <div className={styles.formGroup}>
                            <div className={styles.passwordContainer}>
                                <label htmlFor="password">Passwort</label>
                                <a className={styles.forgotPasswordLink} onClick={() => setResetPasswordPopup(true)}>Passwort vergessen?</a>
                            </div>
                            <input type="password"
                                id="password"
                                name="password"
                                value={formLoginData.password}
                                onChange={handleChange}
                                required />
                        </div>
                        <div className={styles.buttonContainer}>
                            <button type="submit" className={`${commonStyles.commonButton} ${styles.loginButton}`}>
                                <span>Einloggen</span>
                                <FaArrowAltCircleRight className={commonStyles.commonButtonIcon} />
                            </button>
                        </div>
                        <div className={styles.registerContainer}>
                            <p>Noch keinen Account? </p>
                            <a className={styles.registerLink} onClick={() => { onClose(); togglePopup(); }}>
                                Jetzt Registrieren
                            </a>
                        </div>
                    </div>
                </form>
            </div>

        </div>
        <div className={styles.confirmPopup}>
            <ConfirmEmailResetPasswordPopup isOpen={resetPasswordPopup} onClose={() => setResetPasswordPopup(false)} />
        </div></>
    );
}
